module.exports = __webpack_public_path__ + "img/pixing_xc8.3fa08e72.jpg";